__webpack_require__.p = "/minah-log/";